export default __webpack_public_path__ + "static/media/k_p_img1.66046f24.JPG";